import { render } from "./SubTaskDetail.vue?vue&type=template&id=ee190762"
import script from "./SubTaskDetail.vue?vue&type=script&lang=js"
export * from "./SubTaskDetail.vue?vue&type=script&lang=js"

import "./SubTaskDetail.vue?vue&type=style&index=0&id=ee190762&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__